import { Box, Flex, Text } from '@mantine/core';

import DMText from '@/components/DMText';
import Image from 'next/image';
import ReactPlayer from 'react-player';
import TechstackAvatarBadgeGroup from '@/components/TechstackAvatarBadgeGroup';
import { emojiSource } from '@/utils/utils';
import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';
import { useDiscoveryContentDetailModalStyle } from '@/features/Discovery/discovery.style';
import { useGetContentDetail } from '../hook/api';

const VideoBody = () => {
  const { classes } = useDiscoveryContentDetailModalStyle();

  const { data } = useGetContentDetail();

  return (
    <div
      className={classes.bodyContainer}
      onClick={() => {
        mixpanelTrack('DiscoveryDetailModal_YoutubePlayButton', 'Clicked');
      }}
    >
      <div className={classes.techstack}>
        {data?.content?.techstacks.length || 0 > 0 ? (
          <TechstackAvatarBadgeGroup techstacks={data?.content?.techstacks} />
        ) : (
          <Flex align={'center'} gap={5}>
            <Text size={14} color={themeVariables.fontColors.light} mt={2}>
              * 관련 기술 스택이 없습니다
            </Text>
            <Image
              width={14}
              height={14}
              src={emojiSource('1f605', 'twitter')}
              alt="emoji"
            />{' '}
          </Flex>
        )}
      </div>
      <p className={classes.bodyText}>
        {data?.content?.summary &&
          data?.content.summary.split('\n').map((line, index) => (
            <DMText key={index} dColor={themeVariables.darkMode.normal}>
              {line}
              <br />
            </DMText>
          ))}
      </p>
      <Box sx={{ overflow: 'hidden', borderRadius: 16, marginTop: 40 }}>
        <ReactPlayer
          url={`https://www.youtube.com/embed/${
            data?.content?.url.split('v=')[1]
          }`}
          width={'100%'}
          height={400}
          controls={true}
          light={true}
          config={{
            youtube: {
              playerVars: {
                rel: 0,
                autoplay: 1,
                cc_lang_pref: 'ko',
              },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default VideoBody;
